(() => {
  'use strict';

  const selectors = {
    apiTemplate: '[data-api-related-template]',
    productItem: '.product-item',
    gridItem: '[data-grid-item]',
    relatedSection: '[data-related-section]',
    recentlyViewed: 'recently-viewed',
    gridSlider: 'grid-slider',
    recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  };

  const attributes = {
    limit: 'data-limit',
    productId: 'data-product-id',
    layout: 'data-layout',
  };

  const classes = {
    hidden: 'hidden',
    mobileSlider: 'grid--mobile-slider',
    slider: 'grid--slider',
  };

  if (!customElements.get('related-products')) {
    customElements.define(
      'related-products',
      class RelatedProducts extends HTMLElement {
        constructor() {
          super();

          this.sectionId = this.id;
          this.relatedItems = 0;
          this.recentlyViewedItems = 0;
          this.relatedSection = this.querySelector(selectors.relatedSection);
          this.wrapper = this.querySelector(selectors.recentlyViewedWrapper);
          this.recentlyViewed = this.querySelector(selectors.recentlyViewed);
          this.relatedLoaded = !this.relatedSection;
          this.recentlyViewedLoaded = !this.recentlyViewed;
        }

        connectedCallback() {
          this.loadRelatedProducts();
          this.loadRecentlyViewedProducts();
          this.updateVisibility();
        }

        loadRelatedProducts() {
          if (!this.relatedSection) {
            return;
          }

          const productId = this.relatedSection.getAttribute(attributes.productId);
          const limit = this.relatedSection.getAttribute(attributes.limit);
          const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=related`;

          fetch(requestUrl)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Product recommendations request failed: ${response.status}`);
              }

              return response.text();
            })
            .then((responseText) => this.handleRelatedProductsResponse(responseText))
            .catch(() => this.handleRelatedProductsFailure());
        }

        handleRelatedProductsResponse(responseText) {
          const responseDocument = new DOMParser().parseFromString(responseText, 'text/html');
          const responseTemplate = responseDocument.querySelector(selectors.apiTemplate);

          if (!responseTemplate) {
            this.handleRelatedProductsFailure();
            return;
          }

          const responseContainer = document.createElement('div');
          responseContainer.innerHTML = responseTemplate.innerHTML;

          const relatedItems = responseContainer.querySelectorAll(selectors.gridItem).length;
          this.relatedItems = relatedItems;
          this.relatedLoaded = true;

          if (relatedItems > 0) {
            this.relatedSection.innerHTML = responseContainer.innerHTML;

            const mobileColumns = parseInt(
              this.relatedSection.style.getPropertyValue('--COLUMNS-MOBILE')
            );
            const firstGridItem = this.relatedSection.querySelector(selectors.gridItem);
            const grid = firstGridItem?.parentElement;

            if (grid) {
              if (mobileColumns === 0) {
                grid.classList.add(classes.mobileSlider);
              }

              grid.classList.toggle(
                classes.slider,
                this.relatedSection.getAttribute(attributes.layout) === 'slider'
              );
            }
          } else {
            this.hideSection(this.relatedSection);
          }

          this.updateVisibility();
        }

        handleRelatedProductsFailure() {
          this.relatedItems = 0;
          this.relatedLoaded = true;
          this.hideSection(this.relatedSection);
          this.updateVisibility();
        }

        loadRecentlyViewedProducts() {
          if (!this.recentlyViewed) {
            this.recentlyViewedLoaded = true;
            this.updateVisibility();
            return;
          }

          this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
            this.handleRecentlyViewedResponse();
          });
        }

        handleRecentlyViewedResponse() {
          const minimumItems = parseInt(this.recentlyViewed.dataset.minimum) || 1;
          const items = this.recentlyViewed.querySelectorAll(selectors.productItem);
          const slider = this.recentlyViewed.querySelector(selectors.gridSlider);
          const canShowWithoutTabs = !this.wrapper && items.length > 0;
          const canShowWithTabs = this.wrapper && items.length >= minimumItems;
          const hasVisibleRecentlyViewedItems =
            canShowWithoutTabs || canShowWithTabs;

          this.recentlyViewedItems = hasVisibleRecentlyViewedItems ? items.length : 0;
          this.recentlyViewedLoaded = true;

          if (hasVisibleRecentlyViewedItems) {
            if (canShowWithTabs) {
              this.wrapper.classList.remove(classes.hidden);
            }

            this.recentlyViewed.classList.remove(classes.hidden);
            this.recentlyViewed.dispatchEvent(
              new CustomEvent('theme:tab:check', {bubbles: true})
            );

            slider?.dispatchEvent(
              new CustomEvent('theme:grid-slider:init', {bubbles: true})
            );
          }

          this.updateVisibility();
        }

        hideSection(section) {
          section?.dispatchEvent(new CustomEvent('theme:tab:hide', {bubbles: true}));
        }

        updateVisibility() {
          const hasVisibleContent =
            this.relatedItems > 0 || this.recentlyViewedItems > 0;
          const allSourcesLoaded = this.relatedLoaded && this.recentlyViewedLoaded;

          if (hasVisibleContent) {
            this.classList.remove(classes.hidden);
          } else if (allSourcesLoaded) {
            this.classList.add(classes.hidden);
          }
        }
      }
    );
  }
})();
